<mat-toolbar>
  <div class="md-toolbar-tools">
    <h1 mat-dialog-title>Log da Fatura</h1>
    <span flex></span>
    <div class="posicionar-direita">
      <button (click)="restaurarDialog()" class="botao-header" [hidden]="!maximizado" matTooltip="Minimizar">
        <mat-icon>fullscreen_exit</mat-icon>
      </button>
      <button (click)="maximizarDialog()" class="botao-header" [hidden]="maximizado" matTooltip="Expandir">
        <mat-icon>fullscreen</mat-icon>
      </button>
      <button (click)="fecharDialog()" class="botao-header" matTooltip="Fechar">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</mat-toolbar>
<mat-dialog-content>
  <div class="md-dialog-content">
    <br />
    <div class="row">
      <div class="table-responsive col-md-12">
        <table class="table table-striped" cellspacing="0" cellpadding="0">
          <thead>
            <tr>
              <th>Data</th>
              <th>Tipo</th>
              <th>Mensagem</th>
              <th>Detalhes</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let log of logs">
              <td>{{log.dataHora | date:'dd/MM/yyyy HH:mm:ss'}}</td>
              <td>
                <span [ngClass]="{
                  'status-sucesso': log.tipoLog === 1,
                  'status-erro': log.tipoLog === 0,
                  'status-aviso': log.tipoLog === 2
                }">
                  {{getTipoLogDescricao(log.tipoLog)}}
                </span>
              </td>
              <td>{{log.mensagem}}</td>
              <td>
                <button mat-mini-fab (click)="modalDetalhe(log.detalhes)"
                  *ngIf="log.detalhes != undefined && log.detalhes != null && log.detalhes != ''" matTooltip="Detalhes">
                  <mat-icon>info</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</mat-dialog-content>
